import { useState } from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import { Link} from 'react-router-dom'

import imageNoticias1001 from '../assets/images/noticias/noticias_1_001.jpeg'
import imageNoticias2006 from '../assets/images/noticias/noticias_2_006.jpeg'
import imageNoticias4001 from '../assets/images/noticias/noticias_4_001.jpeg'
import imageNoticias5001 from '../assets/images/noticias/noticias_5_001.jpg'

function UltimasNoticias() {
  const [hover, setHover] = useState(false)
  const content = [
    {
      id: 3,
      title: 'CAMPANHA SALARIAL 2025 - ENTREGA DA PAUTA DEFINE RUMO DAS REIVINDICAÇÕES DOS TRABALADORES POR AVANÇOS',
      slug: 'campanha-salarial-2025-entrega-da-pauta-define-rumo-das-reinvincicacoes-dos-trabalhadores-por-avancos',
      image: imageNoticias5001,
      link: ''
    },
    {
      id: 4,
      title: 'METAL AO LADO DOS TRABALHADORES DA EBARA DEFINE ACORDO DA PLR',
      slug: 'metal-ao-lado-dos-trabalhadores-da-ebara-define-acordo-da-plr',
      image: imageNoticias4001,
      link: '/noticias'
    },
    {
      id: 1,
      title: 'METAL BAURU NAS RUAS POR MAIS DIREITOS PARA TRABALHADORES',
      slug: 'metal-bauru-nas-ruas-por-mais-direitos-para-trabalhadores',
      image: imageNoticias1001,
      link: ''
    },
    {
      id: 2,
      title: 'METAL BAURU MAIS PERTO DA REALIDADE DOS TRABALHADORES',
      slug: 'metal-bauru-mais-perto-da-realidade-dos-trabalhadores',
      image: imageNoticias2006,
      link: ''
    },
  ]
  return (
    <Row style={{ marginTop: '50px', marginBottom: '50px' }}>
      <Col xs={12} sm={12} md={12} lg={12} style={{ fontWeight: '800', fontSize: '40px' }}>
        <span>Últimas notícias</span>
      </Col>
      {content.map((item, index) => (
        <Col xs={12} sm={12} md={3} lg={3} key={item.id}>
          <Link to={'/noticias/'+item.slug}>
            <Card
              className="news-card text-white"
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(null)}
            >
              <Card.Img src={item.image} alt="News background" className="news-card-img" />
              <Card.ImgOverlay className={`d-flex flex-column justify-content-end p-4 fade-overlay ${hover === index ? 'hovered' : ''}`}>
                <Card.Text className="fs-6" style={{ fontWeight: '700' }}>{item.title}</Card.Text>
              </Card.ImgOverlay>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>
  )
}

export default UltimasNoticias